module.exports = __webpack_public_path__ + "img/tu15.5f2fd76d.jpg";